import gql from 'graphql-tag';


export const PORTAL_ACCOUNT_INFO = gql`
    query portalUser($id: String!){
        portalUser(id: $id){
            user{
                name
                phone
                email
            }
        }
    }
`;

export const PORTAL_ACCOUNT_UPDATE = gql`
    mutation updatePortalUser($data: UpdatePortalUserInput!) {
        updatePortalUser(data: $data) {
            portalUser {
                user {
                    id
                    email
                    phone
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/graphql.js